export const normalizeClientData = (data) => {
  const dataSource = data.map((item, index) => {
    return {
      key: `${item.clie_id}_${index}`,
      clie_id: item.clie_id,
      Nombre: `${item.clie_nombre} ${item.clie_ap} ${item.clie_am}`,
      RFC: item.clie_rfc,
      clie_rfc: item.clie_rfc,
      clie_regimen_fiscal: item.clie_regimen_fiscal,
      Correo: item.clie_correo,
      Telefono: item.clie_tel,
      Tipo: item.clie_tipo === 1 ? 'Persona Física' : 'Persona Moral',
      clie_ap: item.clie_ap,
      clie_am: item.clie_am,
      clie_nombre: item.clie_nombre,
      clie_tel: item.clie_tel,
      clie_correo: item.clie_correo,
      clie_activo: item.clie_activo,
      clie_tipo: item.clie_tipo,
      clie_cp: item.clie_cp
    };
  });
  const columns = Object.keys(dataSource[0] || {})
    .map((key) => {
      const hiddenColumns = [
        'key',
        'clie_ap',
        'clie_am',
        'clie_regimen_fiscal',
        'clie_activo',
        'clie_tipo',
        'clie_id',
        'clie_nombre',
        'clie_tel',
        'clie_correo',
        'clie_rfc',
        'clie_cp'
      ];
      if (!hiddenColumns.includes(key)) {
        return { title: key, dataIndex: key, key };
      }
      return null;
    })
    .filter((col) => col !== null);

  return { dataSource, columns };
};
export const normalizeClientDataForExport = (data) => {
  return data.map((item) => {
    return {
      Nombre: `${item.clie_nombre} ${item.clie_ap} ${item.clie_am}`,
      RFC: item.clie_rfc,
      Correo: item.clie_correo,
      Telefono: item.clie_tel,
      Tipo: item.clie_tipo === 1 ? 'Persona Física' : 'Persona Moral',
      Activo: item.clie_activo ? 'Sí' : 'No',
    };
  });
};
